module.exports = __webpack_public_path__ + "media/images/values/loyal-9b0ec1eb227e8685b5155645aac3edac.svg";